import useragent from '@finance/useragent'

export const getClientInfo = (requestInfo: string[]) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      window.sui.getClientInfo({
        requestInfo,
        success: (res: any) => {
          if (res.code !== 0) {
            reject(new Error(res.message || '获取信息失败'))
            return
          }
          resolve(res.result)
        },
        error: () => {
          reject(new Error('获取信息失败'))
        }
      })
    })
  })
}

/**
 * 获取手机信息
 */
export const getPhoneInfo = () => {
  return new Promise((resolve, reject) => {
    getClientInfo(['phoneInfo']).then((res: any) => {
      if (res && res.phoneInfo && res.phoneInfo.code === 0) {
        resolve(res.phoneInfo.result)
        return
      }
      reject(new Error('获取手机信息失败'))
    }).catch((e) => {
      reject(e)
    })
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return new Promise((resolve, reject) => {
    getClientInfo(['userInfo']).then((res: any) => {
      if (res && res.userInfo && res.userInfo.code === 0) {
        resolve(res.userInfo.result)
        return
      }
      reject(new Error('获取用户信息失败'))
    }).catch((e) => {
      reject(e)
    })
  })
}

export const requestHWPay = (info: any) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      console.info('huaweipay: requestHWPay param:', info)
      window.sui.requestHWPay({
        ...info,
        success: (res: any) => {
          if (res.code !== 0) {
            reject(res.message || '支付服务异常')
            return
          }
          resolve(res.result)
        },
        error: (e: any) => {
          if (e && e.msg === 'Api apply timeout') {
            console.log(e.msg)
          } else {
            reject(e ? (e.msg || '支付服务异常') : '支付服务异常')
          }
        }
      })
    })
  })
}

export const callInAppPurchase = (info: any) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      console.info('applepay: callInAppPurchase param:', info)
      window.sui.callInAppPurchase({
        ...info,
        success: (res: any) => {
          console.info('applepay: success:', res)
          if (res.code !== 0) {
            reject(res.message || '支付服务异常')
            return
          }
          resolve(res.result)
        },
        error: (e: any) => {
          if (e && e.msg === 'Api apply timeout') {
            console.log(e.msg)
          } else {
            reject(e ? (e.msg || '支付服务异常') : '支付服务异常')
          }
        }
      })
    })
  })
}

/**
 * 开启关闭页面弹性效果
 */
export const closeWebViewBounce = () => {
  return new Promise<void>((resolve, reject) => {
    window.sui.ready(() => {
      window.sui.enableWebViewBounce({
        enable: false, // 是否开启
        success: () => {
          console.log('关闭回弹成功')
          resolve()
        },
        error: () => {
          console.log('关闭回弹失败')
          reject()
        }
      })
      // window.sui.enablePullRefresh({
      //   enable: false, // 是否开启
      //   success: () => {
      //     console.log('关闭刷新成功')
      //     resolve()
      //   },
      //   error: () => {
      //     console.log('关闭刷新失败')
      //     reject()
      //   }
      // })
    })
  })
}

/**
 * 下载文件
 */
export const downloadImage = (url: string) => {
  return new Promise((resolve, reject) => {
    window.sui.ready(() => {
      window.sui.downloadImage({
        imageUrl: url,
        waitUserAction: true,
        success() {
          console.log('下载成功')
          resolve(true)
        },
        error(e: any) {
          console.log('下载失败')
          reject(e)
        }
      })
    })
  })
}

/**
 * 获取用户当前账本信息
 */
export const queryUserCurrentAccountBookInfo = () => {
  return new Promise((resolve, reject) => {
    window.sui.ready(() => {
      window.sui.queryUserCurrentAccountBookInfo({
        success(res: any) {
          console.log('获取用户当前账本信息成功')
          resolve(res)
        },
        error(e: any) {
          console.log('获取用户当前账本信息失败')
          reject(e)
        }
      })
    })
  })
}
